var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1L16 4M1 16L1.9573 12.4899C2.01976 12.2609 2.05098 12.1464 2.09892 12.0396C2.14149 11.9448 2.19379 11.8547 2.25499 11.7707C2.32391 11.6761 2.40783 11.5922 2.57568 11.4243L10.3257 3.67426C10.4742 3.52576 10.5485 3.4515 10.6341 3.42368C10.7094 3.39921 10.7906 3.39921 10.8659 3.42368C10.9515 3.4515 11.0258 3.52576 11.1743 3.67426L13.3257 5.82574C13.4742 5.97424 13.5485 6.0485 13.5763 6.13412C13.6008 6.20944 13.6008 6.29057 13.5763 6.36588C13.5485 6.45151 13.4742 6.52576 13.3257 6.67427L5.57568 14.4243C5.40783 14.5922 5.32391 14.6761 5.22931 14.745C5.14532 14.8062 5.05519 14.8585 4.96039 14.9011C4.85361 14.949 4.73911 14.9802 4.5101 15.0427L1 16Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.fc5a04cdb2cfc6f2def99310777c309b.svg";
export { ForwardRef as ReactComponent };